import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlgOnboardingComponent } from './pages/alg-onboarding/alg-onboarding.component';
import { AlgWipComponent } from './pages/alg-wip/alg-wip.component';

import { AlgScontoComponent } from './pages/alg-sconto/alg-sconto.component';
import { AlgSwitchFisicoPageComponent } from './pages/alg-switch-fisico-page/alg-switch-fisico-page.component';
import { AlgFisicoComponent } from './pages/alg-fisico/alg-fisico.component';
import { ConsensoModule } from './consenso.module';
import { AlgAutoricaricaComponentComponent } from './pages/alg-autoricarica/alg-autoricarica.component';


const appRoutes: Routes = [
  { path: 'onb/:prodotto', component: AlgOnboardingComponent },
  { path: 'onb/:prodotto/:primary', component: AlgOnboardingComponent },
  {
    path: 'onb/:prodotto/:primary/:secondary',
    component: AlgOnboardingComponent,
  },
  {
    path: 'onb/:prodotto/:primary/:secondary/:tertiary',
    component: AlgOnboardingComponent,
  },
  { path: 'consenso', redirectTo: 'consenso/' },
  { path: 'consenso_richiesta', loadChildren: () => ConsensoModule },
  { path: 'autoricarica', redirectTo: 'autoricarica/' },
  { path: 'autoricarica', component: AlgAutoricaricaComponentComponent},
  { path: 'consenso', loadChildren: () => ConsensoModule },
  { path: 'fisico/:id', component: AlgSwitchFisicoPageComponent },
  { path: 'scontodipendenti', component: AlgScontoComponent },
  { path: 'maintenance-period', component: AlgWipComponent },
  { path: '', component: AlgOnboardingComponent },
  // { path: '**', redirectTo: '' },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);

export const pageComponents: any[] = [
  AlgOnboardingComponent,
  AlgWipComponent,
  AlgSwitchFisicoPageComponent,
  AlgScontoComponent,
  AlgFisicoComponent,
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts